import React from 'react'

import {
  useColorScheme,
  View,
  StyleSheet,
  Dimensions,
  ActivityIndicator,
  Modal,
} from 'react-native';

import Colors from '../../constants/Colors';
import ReuseAccessPanel from './ReuseAccessPanel';
import ReuseList from './ReuseList';
import ReuseTrackingPanel from './ReuseTrackingPanel';

interface Props {
}

const ReuseDashboard: React.FC<Props> = ({ 
}) => {   
  return (<View style={styles.container}>
            <View style={styles.mainContainer}>
              <ReuseList />
            </View>
            <View style={styles.sideContainer}>
              <ReuseTrackingPanel />
              <View style={{marginTop: 10}}>
                <ReuseAccessPanel />
              </View>
            </View>
          </View>
  )
};

const width = Dimensions.get('window').width;

const styles = StyleSheet.create({ 
  stat: {
    fontSize: 26,
    fontWeight: 'bold',
  },

  statTitle: {
    fontSize: 20,
  },

  statsContainer: {
    width: width / 2 - 10,
    alignItems: 'center',
    marginHorizontal: 5,
    marginVertical: 20,
  },

  loadingText: {
    textAlign: 'center',
    padding: 10,
    fontWeight: 'bold'
  },

  button : {
    margin: 4,
  },

  modalView: {

  },

  modalText: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 20,
    margin: 20,
  },

  entryButton: {
    width: width - 20,
    marginLeft: 10,
    marginTop: 10,
  },

  inputLabel: {
    fontSize: 16,
    marginTop: 10,
    marginLeft: 15,
  },

  inputGroup: {
    flexDirection: 'row',
    marginLeft: 5,
  },

  input: {
    height: 50,
    width: width - 20,
    paddingVertical: 10,
    paddingHorizontal: 20,
    margin: 10,
    flex: 1,
    borderColor: Colors.borderGrey,
    borderWidth: 1,
    borderRadius: 20
  },

  container: {
    flexDirection: 'row'
  },

  mainContainer: {
    margin: "2%",
    width: "66%",
  },

  sideContainer: {
    marginTop: "2%",
    marginRight: "2%",
    width: "28%",
  },
});
export default ReuseDashboard